import React from 'react';
import connect from "react-redux/es/connect/connect";
import {bindActionCreators} from "redux";
import _ from "lodash";
import {deleteMedia, fetchMedia, resetMedia, updateMedia} from "../../../creators/media";

import "./MediaEdit.scss";
import {PageLoader} from "../../components/Loader";
import InformationGeneral from "./components/informationGeneral/InformationGeneral";
import {Button} from "../../components/Button";
import {Can} from "../../../ability-context";
import SelectCoverVideo from "./components/selectCoverVideo/SelectCoverVideo";
import Categories from "./components/categories/Categories";
import Alert from "../../components/Alert";
import Modal from "../../components/Modal";



class MediaEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentMedia: {
                title : "",
                contentRaw : {}
            },
            currentTab : 0
        };
        this.handleCurrentMedia = this.handleCurrentMedia.bind(this);
        this.handleDeleteMedia = this.handleDeleteMedia.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.props.resetMedia();
        this.props.fetchMedia(this.props.currentMediaId, {edition : true});

    }

    componentDidUpdate(prevProps) {
        if (_.get(this.props, "media._id") && _.get(this.props, "media._id") !== _.get(prevProps, "media._id")) {
            let media = this.props.media;
            this.setState({
                currentMedia: {
                    _id: media._id,
                    title: media.title,
                    contentRaw: media.contentRaw,
                },
                currentTab : 0
            });
        }
    }

    componentWillUnmount() {
        this.setState({currentMedia: {}, currentTab : 0});
        this.props.resetMedia();
    }

    handleCurrentMedia(name, value) {
        let currentMedia = this.state.currentMedia;
        let newCurrentMedia = {...currentMedia, [name]: value};
        this.setState({currentMedia: newCurrentMedia});
    }

    handleDeleteMedia() {
        this.props.deleteMedia(this.props.media._id);
        this.setState({toggleAlertDeleteMedia: false});
        this.props.handleClose();
    }

    handleSubmit() {
        let currentMedia = this.state.currentMedia;
        if(currentMedia.title.length >0 ){
            this.props.updateMedia(this.props.media._id, currentMedia);
            this.props.handleClose();
        }
    }


    render() {
        let cover = "";
        if(this.props.media.kind === "video"){
            cover = this.props.media.videoCoverUrl ? this.props.media.videoCoverUrl : (this.props.media.previewUrl && this.props.media.previewUrl[0]) || "";
        }
        else{
            cover = this.props.media.previewUrl;
        }

        return <div id={"media-edit"}>
            {!this.props.mediaInitialized || !this.state.currentMedia._id ? (
                <PageLoader/>
            ) : (
                <>
                    <Modal toggle={this.state.toggleAlertDeleteMedia}
                           handleClose={() => this.setState({toggleAlertDeleteMedia: false})}>
                        <Alert handleDelete={() => this.handleDeleteMedia()}
                               handleClose={() => this.setState({toggleAlertDeleteMedia: false})}
                               text={`Voulez-vous vraiment supprimer cette ${_.get(this.props,"media.kind") === "video" ? "vidéo" : "photo"} ?`}/>
                    </Modal>
                    <div className={"media-edit-header"}>
                        <div className={"media-edit-title"}>
                            Editer le media
                        </div>
                    </div>
                    <div className={"media-edit-content"}>
                        <div className={"media-edit-thumb"} style={{backgroundImage: `url(${cover}?width=400&height=400)`}} />
                        <div className={"media-edit-group-tab"}>
                            <div
                                className={`media-edit-tab ${this.state.currentTab === 0 ? "active" : ""}`}
                                onClick={() => this.setState({currentTab : 0})}
                            >
                                Informations générales
                            </div>
                            <div
                                className={`media-edit-tab ${this.state.currentTab === 1 ? "active" : ""}`}
                                onClick={() => this.setState({currentTab : 1})}
                            >
                                Tags
                            </div>
                            {this.props.media.kind === "video" ? (<div
                                className={`media-edit-tab ${this.state.currentTab === 2 ? "active" : ""}`}
                                onClick={() => this.setState({currentTab : 2})}
                            >
                                Miniature de la vidéo
                            </div>) : null}
                        </div>
                        {[
                            <InformationGeneral
                                title={this.state.currentMedia.title}
                                contentRaw={this.state.currentMedia.contentRaw}
                                kind={this.props.media.kind}
                                handleCurrentMedia={this.handleCurrentMedia}
                            />,
                            <Categories
                                categoriesHistory={this.props?.media?.categoriesHistory || {}}
                                categoriesMedia={this.props?.media?.categories || []}
                                mediaId={this.props?.media?._id || null}
                                handleClose={()=>this.props.handleClose()}
                            />,
                            <SelectCoverVideo media={this.props.media} />
                        ][this.state.currentTab]}
                    </div>

                    {this.state.currentTab === 0 ? (
                        <div className={"media-edit-footer"}>
                            <div className={"media-edit-footer-left"}>
                                <Can action={"delete"} subject={this.props.media} modelName="Media">
                                    <span className={"media-edit-delete"} onClick={() => this.setState({toggleAlertDeleteMedia: true})}>Supprimer cette {_.get(this.props,"media.kind") === "video" ? "vidéo" : "photo"}</span>
                                </Can>
                            </div>
                            <div className={"media-edit-footer-right"}>
                                <Button size={"small"}
                                        btnStyle={"grey"}
                                        onClick={() => this.props.handleClose()}
                                        content={"Annuler"}/>
                                <Can action={"update"} subject={this.props.media} modelName="Media">
                                    <Button btnStyle={"primary-reverse"}
                                            size={"small"}
                                            className={"ml-8"}
                                            disabled={!(this.state.currentMedia.title.length >0)}
                                            loading={this.props.mediaSubmitting}
                                            onClick={() => this.handleSubmit()}
                                            content={"Modifier"}/>
                                </Can>
                            </div>

                        </div>
                    ) : null}

                </>
            )}
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        media: state.media.data,
        mediaLoading: state.media.loading,
        mediaSubmitting: state.media.submitting,
        mediaInitialized: state.media.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchMedia,
    updateMedia,
    deleteMedia,
    resetMedia,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MediaEdit);